function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44.944px",
    height: "33.71px",
    viewBox: "0 0 44.944 33.71",
    style: {
      enableBackground: "new 0 0 44.944 33.71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.9229,
    y1: 2.8682,
    x2: 4.8981,
    y2: 42.8929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2,27.318h40.944c1.104,0,2-0.896,2-2s-0.896-2-2-2H2c-1.104,0-2,0.896-2,2 S0.896,27.318,2,27.318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.1182,
    y1: 6.0635,
    x2: 8.0937,
    y2: 46.0879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M42.944,29.71H2c-1.104,0-2,0.896-2,2s0.896,2,2,2h40.944c1.104,0,2-0.896,2-2 S44.049,29.71,42.944,29.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8389,
    y1: -1.2163,
    x2: 0.8137,
    y2: 38.8088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M2,21.355c1.104,0,2-0.896,2-2c0-3.032,2.468-5.5,5.5-5.5c0.375,0,0.753,0.039,1.124,0.115 l2.354,0.484l0.05-2.402C13.117,7.612,16.802,4,21.24,4c3.827,0,7.113,2.605,7.99,6.336l0.514,2.183l2.11-0.759 c0.747-0.269,1.514-0.404,2.278-0.404c3.722,0,6.75,3.028,6.75,6.75c0,1.104,0.896,2,2,2s2-0.896,2-2 c0-5.928-4.822-10.75-10.75-10.75c-0.547,0-1.093,0.043-1.635,0.128C30.625,2.992,26.243,0,21.24,0 C15.361,0,10.372,4.262,9.258,9.858C4.131,9.988,0,14.198,0,19.355C0,20.46,0.896,21.355,2,21.355z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon-7.02fe5d916c77d8f16b9e1ee9997511dd.svg";
export { ForwardRef as ReactComponent };